import React from 'react';

const ArrowRightBlack = (props) => (
  <img
    {...props}
    src={`${MEDIA_ROOT}/icons/icn_arrowright_black.svg`}
    alt="Arrow right"
  />
);

export default ArrowRightBlack;
